export const CalendarLarge = () => (
  <svg width="28" height="32" viewBox="0 0 28 32" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M7 0C7.5 0 8 0.5 8 1V4H20V1C20 0.5 20.4375 0 21 0C21.5 0 22 0.5 22 1V4H24C26.1875 4 28 5.8125 28 8V10V12V28C28 30.25 26.1875 32 24 32H4C1.75 32 0 30.25 0 28V12V10V8C0 5.8125 1.75 4 4 4H6V1C6 0.5 6.4375 0 7 0ZM26 12H2V28C2 29.125 2.875 30 4 30H24C25.0625 30 26 29.125 26 28V12ZM24 6H4C2.875 6 2 6.9375 2 8V10H26V8C26 6.9375 25.0625 6 24 6Z"
      fill="currentColor"
    />
  </svg>
);
